import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import LoginForm from '../../components/Forms/LoginForm';

export default class Login extends Component {

  render() {
    const { route } = this.props;
    return (
      <div className="Login">
        <Helmet
          title={route.meta.site_name}
          meta={ [
            { name: "description", content: route.meta.meta_about },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <div className="column-center column-s">
          <LoginForm />
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/views/Login/Login.js